// Tenant kullanıcısına abonelik durumu + limit uyarısı banner
// Sadece kritik durumlarda görünür (trial bitiyor, limit %80+, vade geçti vs.)
import React, { useEffect, useState } from 'react';
import api from '../services/api';

export default function SubscriptionBanner() {
  const [data, setData] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get('/subscription/status').then(r => {
      if (r.data.success) setData(r.data.data);
    }).catch(() => {});
  }, []);

  if (!data || dismissed) return null;
  const c = data.company;
  if (!c) return null;

  // Hangi banner gösterilsin?
  let banner = null;
  if (c.subscription_status === 'trial' && data.days_left != null) {
    if (data.days_left < 0) {
      banner = { type: 'error', text: `⏰ Deneme süreniz doldu! Devam etmek için plan satın alın.`, cta: 'Plan Seç' };
    } else if (data.days_left <= 3) {
      banner = { type: 'warning', text: `🔔 Deneme süreniz ${data.days_left === 0 ? 'bugün' : data.days_left + ' gün içinde'} sona eriyor.`, cta: 'Plan Seç' };
    } else if (data.days_left <= 7) {
      banner = { type: 'info', text: `📅 Deneme süreniz ${data.days_left} gün kaldı.` };
    }
  } else if (c.subscription_status === 'past_due') {
    banner = { type: 'error', text: `💸 Faturanız vadesinde ödenmedi. Hesabınız 7 gün sonra askıya alınacak.`, cta: 'Faturalarım' };
  } else if (c.subscription_status === 'suspended') {
    banner = { type: 'error', text: `🚫 Aboneliğiniz askıya alındı. Lütfen bizimle iletişime geçin.` };
  }

  // Limit uyarıları (banner yoksa)
  if (!banner && data.limits) {
    for (const [key, l] of Object.entries(data.limits)) {
      if (l && !l.unlimited && l.percentage >= 100) {
        banner = { type: 'error', text: `⚠ ${({ user:'Kullanıcı', stock:'Stok', account:'Cari', monthly_invoice:'Aylık Fatura', storage:'Depolama' })[key]} sınırınız doldu (${l.used}/${l.limit}). Plan yükseltin.`, cta: 'Plan Yükselt' };
        break;
      }
      if (l && !l.unlimited && l.percentage >= 80) {
        banner = { type: 'warning', text: `📊 ${({ user:'Kullanıcı', stock:'Stok', account:'Cari', monthly_invoice:'Aylık Fatura', storage:'Depolama' })[key]} sınırına yaklaşıyorsunuz: ${l.used}/${l.limit} (%${l.percentage}).` };
        break;
      }
    }
  }

  if (!banner) return null;
  const colors = {
    error:   { bg: 'rgba(239,68,68,0.12)',   border: 'var(--danger)',  clr: '#991b1b' },
    warning: { bg: 'rgba(245,158,11,0.12)',  border: '#f59e0b',        clr: '#92400e' },
    info:    { bg: 'rgba(59,130,246,0.10)',  border: 'var(--info)',    clr: '#1e3a8a' },
  };
  const col = colors[banner.type];

  return (
    <div style={{
      padding: '8px 14px',
      background: col.bg,
      borderBottom: `2px solid ${col.border}`,
      color: col.clr,
      display: 'flex', alignItems: 'center', gap: 10,
      fontSize: 13, fontWeight: 500,
    }}>
      <span style={{ flex: 1 }}>{banner.text}</span>
      {banner.cta && <a href="#aboneligim" style={{ color: col.clr, fontWeight: 700, textDecoration: 'underline' }}>{banner.cta}</a>}
      <button onClick={() => setDismissed(true)} style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: col.clr, fontWeight: 700, padding: '0 8px' }}>✕</button>
    </div>
  );
}
